var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPersonRed = function SvgPersonRed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#F44336",
    strokeWidth: 1.5,
    d: "M7.5.75c1.658 0 3 1.342 3 3s-1.342 3-3 3-3-1.342-3-3 1.342-3 3-3Zm6.75 12.36a.4.4 0 0 1-.066.07c-.109.094-.307.21-.62.327-.619.232-1.486.4-2.407.514-.91.114-1.825.172-2.516.2a36 36 0 0 1-1.063.029h-.156a31 31 0 0 1-1.063-.029 32 32 0 0 1-2.516-.2c-.92-.115-1.788-.282-2.408-.514-.312-.117-.51-.233-.619-.327a.4.4 0 0 1-.066-.07c.01-.733.647-1.7 1.962-2.54 1.28-.817 3.015-1.383 4.788-1.383s3.508.566 4.788 1.383c1.315.84 1.953 1.807 1.962 2.54Zm.005-.011-.003.006zm-13.51 0 .003.006z"
  })));
};
export default SvgPersonRed;